import { z } from 'zod';
import { EmailTemplateType } from './email-template.dto';

export const EmailTemplateSchema = z.object({
  _id: z.string().optional(),
  companyId: z.string(),
  type: z.enum(
    Object.values(EmailTemplateType) as [
      EmailTemplateType,
      ...EmailTemplateType[],
    ],
  ),
  template: z.object({
    subject: z.string(),
    bodyText: z.string(),
  }),
  createdBy: z.string(),
});

export const UpdateEmailTemplateSchema = EmailTemplateSchema.pick({
  type: true,
  template: true,
});
